import { Navigate, Route, Routes } from 'react-router-dom'
import { useSession } from './lib/useSession'
import { LoginPage } from './pages/Login'
import { DashboardPage } from './pages/Dashboard'
import { SettingsPage } from './pages/Settings'
import { LiverDetailPage } from './pages/LiverDetail'
import { TasksPage } from './pages/Tasks'
import { ReportsPage } from './pages/Reports'
import { FeedbackPage } from './pages/Feedback'
import { LinePage } from './pages/Line'
import { LineImportDetailPage } from './pages/LineImportDetail'
import { LiversPage } from './pages/Livers'
import { HandoffsPage } from './pages/Handoffs'
import { ResetPasswordPage } from './pages/ResetPassword'

export default function App() {
  const session = useSession()

  // initial getSession in-flight
  if (session === undefined) {
    return (
      <div className="h-full flex items-center justify-center text-gray-400 text-sm">
        読み込み中…
      </div>
    )
  }

  const requireAuth = (el: React.ReactElement) =>
    session ? el : <Navigate to="/login" replace />

  return (
    <Routes>
      <Route
        path="/login"
        element={session ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route path="/reset-password" element={<ResetPasswordPage hasSession={Boolean(session)} />} />
      <Route path="/" element={requireAuth(<DashboardPage />)} />
      <Route path="/tasks" element={requireAuth(<TasksPage />)} />
      <Route path="/reports" element={requireAuth(<ReportsPage />)} />
      <Route path="/feedback" element={requireAuth(<FeedbackPage />)} />
      <Route path="/line" element={requireAuth(<LinePage />)} />
      <Route path="/line/imports/:lineImportId" element={requireAuth(<LineImportDetailPage />)} />
      <Route path="/livers" element={requireAuth(<LiversPage />)} />
      <Route path="/handoffs" element={requireAuth(<HandoffsPage />)} />
      <Route path="/liver/:liverId" element={requireAuth(<LiverDetailPage />)} />
      <Route path="/settings" element={requireAuth(<SettingsPage />)} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
